import ScalarDropdownMenu_vue_vue_type_script_setup_true_lang_default from "./ScalarDropdownMenu.vue_vue_type_script_setup_true_lang.js";
//#region src/components/ScalarDropdown/ScalarDropdownMenu.vue
var ScalarDropdownMenu_default = ScalarDropdownMenu_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { ScalarDropdownMenu_default as default };

//# sourceMappingURL=ScalarDropdownMenu.vue.js.map